import React, { useState, useRef } from 'react';
import { Icon } from 'semantic-ui-react';
import { useIntl, defineMessages } from 'react-intl';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import rightKeySVG from '@plone/volto/icons/right-key.svg';
import leftKeySVG from '@plone/volto/icons/left-key.svg';

const messages = defineMessages({
  play: {
    id: 'Play slider',
    defaultMessage: 'Inizia la rotazione automatica degli elementi',
  },
  pause: {
    id: 'Pause slider',
    defaultMessage: 'Metti in pausa la rotazione automatica degli elementi.',
  },
  prevArrow: {
    id: 'Previous slider',
    defaultMessage: 'Slide precedente',
  },
  nextArrow: {
    id: 'Next slider',
    defaultMessage: 'Prossimo slide',
  },
  sliderDot: {
    id: 'Slider Dot',
    defaultMessage: 'Slider numero ', //Lasciare spazio dopo il testo
  },
});

interface SliderWrapperProps {
  autoplay?: boolean;
  autoplay_speed?: number;
  slidesToShow?: number;
  slidesToShowOnMobile?: number;
  show_dots?: boolean;
  n_items?: number;
  settings?: object;
}

const SliderWrapper: React.FC<SliderWrapperProps> = ({
  autoplay = false,
  autoplay_speed = 2,
  slidesToShow = 1,
  slidesToShowOnMobile = 1,
  show_dots = true,
  n_items = 0,
  children,
  settings = {},
}) => {
  const intl = useIntl();
  const slider = useRef(null);
  const [userAutoplay, setUserAutoplay] = useState(autoplay);
  const nSlidesToShow = parseInt(slidesToShow);

  const toggleAutoplay = () => {
    if (!slider?.current) return;
    if (userAutoplay) {
      setUserAutoplay(false);
      slider.current.slickPause();
    } else {
      setUserAutoplay(true);
      slider.current.slickPlay();
    }
  };

  let setInfiniteScroll;
  if (n_items > slidesToShow) {
    setInfiniteScroll = true;
  } else {
    setInfiniteScroll = false;
  }
  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        title={intl.formatMessage(messages.nextArrow)}
        className={className}
        style={{ ...style }}
        onClick={onClick}
      >
        <Icon name={rightKeySVG} />
      </div>
    );
  };

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        title={intl.formatMessage(messages.prevArrow)}
        className={className}
        style={{ ...style }}
        onClick={onClick}
      >
        <Icon name={leftKeySVG} />
      </div>
    );
  }

  const sliderSettings = {
    dots: show_dots,
    infinite: setInfiniteScroll,
    autoplay: autoplay,
    speed: 1000,
    slidesToShow: nSlidesToShow,
    slidesToScroll: nSlidesToShow,
    autoplaySpeed: autoplay_speed * 1000,
    pauseOnHover: true,
    pauseOnFocus: true,
    pauseOnDotsHover: true,
    swipe: true,
    swipeToSlide: true,
    focusOnSelect: true,
    draggable: true,
    accessibility: true,
    adaptiveHeight: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    customPaging: (i) => (
      <button title={intl.formatMessage(messages.sliderDot) + (i + 1)}>
        {i + 1}
      </button>
    ),
    responsive: [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: slidesToShowOnMobile ?? 1,
          slidesToScroll: slidesToShowOnMobile ?? 1,
        },
      },
    ],
    ...settings,
  };

  return n_items > 0 ? (
    <div className={`slider-wrapper ${nSlidesToShow > 1 ? 'multislides' : ''}`}>
      {n_items > nSlidesToShow && (
        <div className="play-pause-wrapper">
          <button
            onClick={() => toggleAutoplay()}
            title={
              userAutoplay
                ? intl.formatMessage(messages.pause)
                : intl.formatMessage(messages.play)
            }
          >
            <Icon name={userAutoplay ? 'pause' : 'play'} />
            <span>{userAutoplay ? 'pause' : 'play'}</span>
          </button>
        </div>
      )}

      <Slider {...sliderSettings} ref={slider}>
        {children}
      </Slider>
    </div>
  ) : null;
};

export default SliderWrapper;
